import { ENV, environmentVariable } from '@application/env';

export const endpoint = () => {
  return environmentVariable(ENV.ENDPOINT);
};
